import React, { useState } from 'react';
import { StandAloneLink } from '@hz-design-system/web-ui';
import { useI18nContext } from '@ecg-internal/js-react-i18n';

import { trackGAEvent } from '../../../../../../utils/gaTracking';
import { GA_TRACK_EVENTS_ACTIONS, GA_TRACK_EVENTS_LABELS } from '../../../../../../utils/constants';
import Modal from '../Modal/Modal';

import Classes from './ModalLink.module.scss';

const BuyersProtectionModalLink = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useI18nContext();

  const handleClick = () => {
    trackGAEvent(GA_TRACK_EVENTS_ACTIONS.Click, GA_TRACK_EVENTS_LABELS.BuyerProtection, { category: 'VIP' });
    setIsOpen(!isOpen);
  };

  return (
    <>
      <StandAloneLink
        iconLeft="veilig-handelen"
        iconRight="info"
        onClick={handleClick}
        className={Classes.buyerProtectionModalLink}
        data-testid="buyerProtectionModalLink"
      >
        <span className={Classes.label}>{t('buyerProtection.availableText')}</span>
      </StandAloneLink>
      {isOpen && <Modal onClose={() => setIsOpen(false)} />}
    </>
  );
};

export default BuyersProtectionModalLink;
